export const SearchBoxDialogName = 'SearchBoxDialog' as const;
export const VehicleWidgetDialogName = 'VehicleWidgetDialog' as const;
export const FacetDialogName = 'FacetDialog' as const;
export const ContextDialogName = 'ContextDialog' as const;
export const SimpleColorPaletteDialogName = 'SimpleColorPaletteDialog' as const;
export const ColorExtractorDialogName = 'ColorExtractorDialog' as const;
export const AutoSyncVisualizationDialogName = 'AutoSyncVisualizationDialog' as const;

export const GarageSearchBoxName = 'GarageSearchBox' as const;
export const FacetTilesVehicleWidgetName = 'FacetTilesVehicleWidget' as const;
export const DialogVehicleWidgetName = 'DialogVehicleWidget' as const;
export const HeaderVehicleWidgetName = 'HeaderVehicleWidget' as const;
export const HomeVehicleWidgetName = 'HomeVehicleWidget' as const;
export const TabsVehicleWidgetName = 'TabsVehicleWidget' as const;
export const VehicleSpecsName = 'VehicleSpecs' as const;
